/* eslint-disable @typescript-eslint/no-unused-vars */
 
// user-profile-form.component.ts
import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { UserProfileService } from '../../../services/auth/user-profile.service';
import { UserProfile } from '@app-libs/model';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { AuthService } from '../../../services/auth/auth.service';
import { HeaderComponent } from '../../../login/header/header.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
  selector: 'app-user-profile-form',
  imports: [
    MatFormFieldModule,
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    CommonModule,
    MatInputModule,
    HeaderComponent,
    MatDividerModule,
  ],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class UserProfileFormComponent implements OnInit, OnDestroy {
  userForm: FormGroup;
  preferencesCollapsed = true; // Add this property
  infoCollapsed = true; // Add this property for the new section
  private destroy$ = new Subject<void>(); // Add this property


  add_info_placeholder = `I’m 15 years old, in Grade 10, I follow the CAPS curriculum and I go to ABC High School. I play rugby and chess, and enjoy video games in my free time.`;
  subheading =
    "Sharing details like your name, grade, and curriculum helps StudyBru create a learning vibe that's lekker and personalised just for you. ";

  user_message = '';

  constructor(
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private auth: AuthService,
    private profileService: UserProfileService
  ) {
    this.userForm = this.fb.group({
      first_name: ['', [Validators.required, Validators.maxLength(100)]],
      last_name: ['', [Validators.maxLength(100)]],
      // preferences: this.fb.array([]),
      additional_info: ['', [Validators.required, Validators.maxLength(500)]], // Add this control for the new section
    });
  }

  ngOnInit(): void {
    this.auth
      .getUserProfile()
      .pipe(takeUntil(this.destroy$))
      .subscribe((profile) => {
        console.log('patchFormValues:', profile);
        this.patchFormValues(profile);
        // this.setPreferences(profile?.preferences || {});
      });
  }

  private patchFormValues(profile: UserProfile): void {
    this.userForm.patchValue(
      {
        first_name: profile?.first_name || '',
        last_name: profile?.last_name || '',
        additional_info: profile?.additional_info || '', // Patch the value for the new section
      },
      { emitEvent: false }
    );
    // this.setPreferences(profile?.preferences || {});
  }

  get preferences(): FormArray {
    return this.userForm.get('preferences') as FormArray;
  }

  setPreferences(preferences: Record<string, any>): void {
    const preferenceArray = Object.entries(preferences || {}).map(
      ([key, value]) =>
        this.fb.group({
          key: [key, [Validators.maxLength(100)]],
          value: [value, [Validators.maxLength(200)]],
        })
    );
    this.userForm.setControl('preferences', this.fb.array(preferenceArray));
  }

  addPreference(): void {
    this.preferences.push(
      this.fb.group({
        key: ['', [Validators.maxLength(100)]],
        value: ['', [Validators.maxLength(200)]],
      })
    );
  }

  removePreference(index: number): void {
    this.preferences.removeAt(index);
  }

  async save() {
    if (this.userForm.valid) {
      console.log('Saving user profile:', this.userForm.value);
      const userId = this.auth.getCurrentUserId();
      if (!userId) {
        console.error('No user ID found');
        this.user_message = 'No user id';
        return;
      }
      await this.profileService
        .updateUserProfile(userId, this.userForm.value)
        .then((profile) => {
          this.user_message = 'Profile updated!';
        })
        .catch((error) => {
          console.error('Error updating profile:', error);
          this.user_message = 'Error updating profile!';
        });
      // Call save service method here if needed
    } else {
      this.user_message = 'Please capture all required fields';
    }
  }

  cancel(): void {
    console.debug('Form canceled');
    this.user_message = '';
    this.snackBar.open('Discarded changes', 'Close', {
      duration: 2000,
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
    this.destroy$.next();

    this.auth.getProfile().then((profile) => {
      this.patchFormValues(profile);
    });
  }

  togglePreferences(event: Event): void {
    event.preventDefault(); // Prevent the default form submission behavior
    this.preferencesCollapsed = !this.preferencesCollapsed; // Toggle the collapsed state
  }

  toggleInfo(event: Event): void {
    event.preventDefault(); // Prevent the default form submission behavior
    this.infoCollapsed = !this.infoCollapsed; // Toggle the collapsed state for the new section
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
